import { apiAction } from '../../../../shared/store/apiAction';

import * as api from './api';
import { fetchSltAmountDetailsTypes } from './types';

export const fetchSltAmountDetails = apiAction({
  types: fetchSltAmountDetailsTypes,
  apiAction: api.fetchSltAmountDetails,
});
